/** A failed request the caller was not allowed to make (HTTP 401/403). */
export const isAccessDenied = (error: unknown): boolean => {
  const status = (error as { response?: { status?: number } } | null)?.response
    ?.status;
  return status === 401 || status === 403;
};
